import { observable } from "mobx";

export class EventErrorModel {
    @observable message: string;
    handler: any;

    constructor(source: EventErrorModel) {
        this.message = source.message;
        this.handler = source.handler;
    }
}